import { __decorate } from "tslib";
import { Component, ViewEncapsulation, } from '@angular/core';
import { SharedHttp } from '../../../../services/http-client.service';
import { Router } from '@angular/router';
import { WebsiteThemeService } from '../../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
var ResetMFAStep;
(function (ResetMFAStep) {
    ResetMFAStep[ResetMFAStep["Confirm"] = 1] = "Confirm";
    ResetMFAStep[ResetMFAStep["Deactivate"] = 2] = "Deactivate";
})(ResetMFAStep || (ResetMFAStep = {}));
/**
 * Modal Component
 */
let ResetMfaConfirmationModalComponent = class ResetMfaConfirmationModalComponent {
    constructor(httpClient, router, sanitizer, themeService) {
        this.httpClient = httpClient;
        this.router = router;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.Step = ResetMFAStep;
        this.successColor = '';
        this.backColor = '';
        this.errorColor = '';
        this.borderRadiusLarger = '';
        this.borderRadiusSmaller = '';
        this.inputBackColor = '';
        this.resetMFAStep = this.Step.Confirm;
        this.mfaRecoveryCode = '';
        this.mfaRecoveryCodeHasError = false;
        document.documentElement.style.overflowY = 'hidden';
        this.themeService.getTheme().subscribe((data) => {
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.backColor = this.themeService.getStyleAttribute('modal_back_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
        });
    }
    ngOnInit() {
        this.user = JSON.parse(localStorage.getItem('user'));
    }
    close() {
        this.modal.destroy();
    }
    closeModal() {
        document.documentElement.style.overflowY = '';
        this.modal.destroy();
    }
    confirm() {
        this.resetMFAStep = this.Step.Deactivate;
    }
    resetMFA() {
        this.httpClient.post('mfa/resetmfa', { id: this.user.id, code: this.mfaRecoveryCode }).subscribe((data) => {
            if (data['canceled']) {
                this.closeModal();
            }
            else {
                this.mfaRecoveryCodeHasError = true;
            }
        });
    }
    mfaRecoveryCodekeyup(e) {
    }
};
ResetMfaConfirmationModalComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: Router },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
ResetMfaConfirmationModalComponent = __decorate([
    Component({
        selector: 'ecd-reset-mfa-confirmation-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./reset-mfa-confirmation-modal.component.html")).default
    })
], ResetMfaConfirmationModalComponent);
export { ResetMfaConfirmationModalComponent };
